import { ZIndex } from '@custom-components';
import { Paper } from '@mui/material';
import styled from 'styled-components';

export const StyledPaper = styled(Paper)`
  position: absolute;
  z-index: ${ZIndex.typeaheadSuggestion};
  max-height: 25vh;
  overflow: auto;

  width: ${({ styling = {} }) => styling.width ?? '100%'};
  right: ${({ styling = {} }) => styling.right ?? 'inherit'};
`;
